import { memo } from "react";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import { useDummyRoomName } from "./hooks";

export const QuestionDummyRoomName = memo(() => {
	const { name, onSetName } = useDummyRoomName();

	const onChange = (value: string) => {
		onSetName(value);
	};

	return (
		<FeatureIslandCategoryQuestionForMain
			required={true}
			title="ダミー部屋名"
			guide="ゲストには表示されません。管理する際、見分けやすい名前を設定しましょう。"
			isEdited={name.isEdited}
			hasError={Boolean(name.error)}
			inputChildren={<InputTextField errorMessage={name.error} value={name.value} handleChange={onChange} />}
		/>
	);
});

QuestionDummyRoomName.displayName = "QuestionDummyRoomName";
